<template>
<div class="signup-container">
  <h1 class="signup-title">회원가입</h1>
  <p class="signup-description">회원가입 유형을 선택해주세요.</p>
  
  <div class="signup-buttons">
    <button class="signup-button organization-button" @click="goToOrganizationSignup">
      기관 관리자 <br />
      (IQC)
    </button>
    <button class="signup-button evaluator-button" @click="goToEvaluatorSignup">
      평가위원 <br />
      (IQA)
    </button>
  </div>
  
  <button class="signup-back-button" @click="goToLogin">
    로그인으로 돌아가기
  </button>
</div>

</template>
   
<script setup>
import { ref, computed, onMounted, onUnmounted ,reactive  } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import * as Utils from '@/common/util/util'
import { userJoin,sendAdminEmail } from '@/api/user'
import { joinOrgCode } from '@/api/org'
const router = useRouter()

const goToEvaluatorSignup = async () => {
    router.push({ name: 'join' })
}

const goToEvaluatorUserSignup = async () => {
    router.push({ name: 'evalJoin' })
}


const goToOrganizationSignup = async () =>{
  router.push({ name: 'orgJoin' })
}

const goToLogin = async () =>{
  router.push({ name: 'login' })
}


</script>

<style scoped>
 .signup-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f9fafc;
  padding: 20px;
}

.signup-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.signup-description {
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}

.signup-buttons {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  line-height: 1.5; /* 줄 간격 조절 */
}

.signup-button {
  padding: 15px 30px;
  font-size: 18px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.signup-button:hover {
  opacity: 0.8;
}

.evaluator-button {
  background-color: #0078d7;
  color: #fff;
  width: 180px;
}

.evaluatorUser-button {
  background-color: #FF7F00;
  color: #fff;
  width: 180px;
}

.organization-button {
  background-color: #28a745;
  color: #fff;
  width: 180px;
}

.signup-back-button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  background-color: #f0f0f0;
  color: #333;
  border-radius: 6px;
  cursor: pointer;
}

.signup-back-button:hover {
  background-color: #ddd;
}


</style>